export const TRANSFER = 'TRANSFER';
export const TRANSFER_ALL = `${TRANSFER}/ALL`;
export const TRANSFER_SEARCH = `${TRANSFER}/SEARCH`;
export const TRANSFER_WEBHOOKS = `${TRANSFER}/WEBHOOKS`;
export const TRANSFER_BY_ID = `${TRANSFER}/BY_ID`;
